module.exports = __webpack_public_path__ + "img/ru_success_3.c116e0bf.png";